import type {
  TaskExecutionSummary,
  TaskFileChangeView,
  TaskResultsView,
  TaskView,
} from '@/lib/api/generated/model';

/**
 * What a decision's agent produced, from what the page already holds (spec
 * 154 R5). Pure, so the choice of run is tested without rendering.
 */

/** How many files a peek lists before "and N more". */
export const PEEK_FILES = 8;

const FINISHED = new Set<TaskExecutionSummary['status']>([
  'completed',
  'failed',
  'stopped',
  'blocked',
]);

/**
 * The most recent finished run on an agent step. A gate's own run and a run
 * still going are not "what it produced"; the agent's last finished one is.
 */
export function latestAgentRun(task: TaskView): TaskExecutionSummary | null {
  let latest: TaskExecutionSummary | null = null;
  for (const run of task.executions ?? []) {
    if (run.step_kind_snapshot !== 'ai' || !FINISHED.has(run.status)) continue;
    if (!latest || run.created_at > latest.created_at) latest = run;
  }
  return latest;
}

/** The files `runId` changed, in the order the service lists them, capped. */
export function filesOfRun(
  results: TaskResultsView,
  runId: string,
  cap: number = PEEK_FILES,
): { files: TaskFileChangeView[]; more: number } {
  const all = (results.files ?? []).filter(
    (file) => file.execution_id === runId,
  );
  return { files: all.slice(0, cap), more: Math.max(0, all.length - cap) };
}
